import styled from 'styled-components';

export default styled.a`
  display: inline-flex;
  margin: 0.5rem 1rem;
  width: 2rem;
  height: 2rem;
  align-items: center;
  justify-content: center;
`;
